import {ReactNode} from "react"

import {useTheme} from "@/hooks/useTheme"

interface IProps {
    message: ReactNode
}

const BotMessage = ({message}: IProps) => {
    const {BotIcon} = useTheme()

    return (
        <div className="m-[20px] ml-0 mr-0 flex items-start justify-start">
            <div className="mr-[10px]">{BotIcon}</div>
            <div className="whitespace-pre-wrap rounded-2xl rounded-tl-none bg-response p-[20px] pb-[12px] pt-[12px]">{message}</div>
        </div>
    )
}

export default BotMessage
